import styled, { css } from 'styled-components';
import { media } from '../../../../theme/shared/breakpoints';
const getMaxWidth = (large, maxWidth) => {
    if (maxWidth)
        return `${maxWidth}px`;
    if (large)
        return '780px';
    return '525px';
};
const BasePopupContainer = styled.div `
  max-width: ${({ large, maxWidth }) => getMaxWidth(large, maxWidth)};
  width: 100%;
  background-color: ${({ theme }) => theme.colorsV2.grayscale.white};
  border-radius: 4px;
  padding: ${({ padding }) => padding || '24px 16px 32px'};
  margin: ${({ fullScreen }) => (fullScreen ? '0!important' : ' 0 16px;')};
  box-shadow: ${({ theme }) => theme.shadows.xlarge};
  ${({ fullScreen }) => fullScreen &&
    css `
      max-width: 100%;
      height: 100%;
    `};

  ${media.medium} {
    padding: 40px 40px 32px 40px;
    margin: 0 40px;
  }

  ${({ isNewDesign, large, maxWidth }) => isNewDesign &&
    css `
      max-width: unset;
      border-radius: 10px;
      width: 100vw;
      margin: 0;

      ${media.large} {
        max-width: ${getMaxWidth(large, maxWidth)};
      }
    `}

  .popup {
    &-header {
      position: relative;
      line-height: 24px;

      button {
        margin: 0;
        padding: 0;
        border: 0;
        background-color: transparent;
        cursor: pointer;
        color: ${({ theme }) => theme.colors.text01};
        position: absolute;
        right: 0;
      }

      svg {
        position: absolute;
        right: 0;
        cursor: pointer;
      }
    }

    &-divider {
      margin: 16px 0;
      border: none;
      border-top: 1px solid ${({ theme }) => theme.colors.ui03};

      ${media.medium} {
        margin: 32px 0;
      }
    }

    &-content {
      max-height: calc(100vh - 90px);
      overflow: auto;
      // for Firefox
      scrollbar-color: ${({ theme }) => theme.colors.text03} transparent;
      scrollbar-width: thin;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: ${({ theme }) => theme.colors.text03};
      }
    }
  }
`;
export default BasePopupContainer;
//# sourceMappingURL=BasePopupContainer.js.map